var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.21,314.78c0-67.47,23.56-124.77,70.72-171.92s104.27-70.73,171.36-70.73,124.19,23.58,171.34,70.73c47.14,47.16,70.72,104.45,70.72,171.92,0,61.34-20.52,114.62-61.53,159.84-41.02,45.23-90.66,71.69-148.91,79.34v150.66h184v62.09h-184v185.16h-63.25v-185.16h-184v-62.09h184v-150.66c-58.28-7.66-107.92-34.11-148.94-79.34-41.02-45.22-61.52-98.5-61.52-159.84ZM383.2,187.12c-35.27,35.28-52.89,77.64-52.89,127.08s17.62,91.81,52.89,127.08,77.62,52.89,127.08,52.89,91.81-17.62,127.08-52.89,52.91-77.62,52.91-127.08-17.64-91.8-52.91-127.08c-35.27-35.27-77.62-52.91-127.08-52.91s-91.81,17.64-127.08,52.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenus);
export default __webpack_public_path__ + "static/media/Venus.d76e8b47cdfe5ae5e051b036f3b168ff.svg";
export { ForwardRef as ReactComponent };